/*eslint-disable*/
import {
  ADD_CLIENT_LOGO,
  ADD_CLIENT_LOGO_ERROR,
  ADD_EMAIL_TEMPLATE_BY_TYPE,
  ADD_EMAIL_TEMPLATE_BY_TYPE_ERROR,
  ADD_TEAM_LOGO,
  ADD_TEAM_LOGO_ERROR,
  ASSET_IMPORT,
  ASSET_IMPORT_ERROR,
  CHECK_ASSET_IMPORT,
  CHECK_ASSET_IMPORT_ERROR,
  CHECK_CLIENT_IMPORT,
  CHECK_CLIENT_IMPORT_ERROR,
  CHECK_DISTRIBUTOR_IMPORT,
  CHECK_DISTRIBUTOR_IMPORT_ERROR,
  CHECK_RELATION_IMPORT,
  CHECK_RELATION_IMPORT_ERROR,
  CHECK_SERVICE_PROVIDER_IMPORT,
  CHECK_SERVICE_PROVIDER_IMPORT_ERROR,
  CLIENT_IMPORT,
  CLIENT_IMPORT_ERROR,
  CREATE_USER,
  CREATE_USER_ERROR,
  DISTRIBUTOR_IMPORT,
  DISTRIBUTOR_IMPORT_ERROR,
  EDIT_ME,
  EDIT_PROPERTIES,
  EDIT_PROPERTIES_ERROR,
  EDIT_PROPERTIES_LIST,
  EDIT_PROPERTIES_LIST_ERROR,
  EDIT_USER,
  EDIT_USER_ERROR,
  GET_ALL_EMAIL_TEMPLATES,
  GET_ALL_EMAIL_TEMPLATES_ERROR,
  GET_ALL_PROPERTIES,
  GET_ALL_PROPERTIES_ERROR,
  GET_AUTH_VALUES,
  GET_AUTH_VALUES_ERROR,
  GET_AVAILABLE_LANGUAGE,
  GET_AVAILABLE_LANGUAGE_ERROR,
  GET_BY_INTERNAL,
  GET_BY_INTERNAL_ERROR,
  GET_CLIENT_LOGO,
  GET_CLIENT_LOGO_ERROR,
  GET_CLIENTS_FILTERED,
  GET_CLIENTS_FILTERED_ERROR,
  GET_EMAIL_TEMPLATE_BY_TYPE,
  GET_EMAIL_TEMPLATE_BY_TYPE_ERROR,
  GET_ME,
  GET_ME_AUTH,
  GET_ME_AUTH_ERROR,
  GET_ME_AUTH_PENDING,
  GET_ME_ERROR,
  GET_USER,
  GET_USER_ERROR,
  GET_USER_ROLE,
  GET_USER_ROLE_ERROR,
  GET_USERS,
  PAGINATE_USERS,
  PAGINATE_USERS_ERROR,
  RELATION_IMPORT,
  RELATION_IMPORT_ERROR,
  SERVICE_PROVIDER_IMPORT,
  SERVICE_PROVIDER_IMPORT_ERROR,
  UPDATE_USER,
  UPDATE_USER_ERROR,
  UPDATE_USER_ME,
  UPDATE_USER_ME_ERROR,
  UPDATE_USERS_ROLE,
  UPDATE_USERS_ROLE_ERROR,
  USERS_ERROR,
} from "../actionTypes";
import axios from "axios";
import { baseUri, baseUriUsers, envHost, loginUri, URL_SERVICE_PERSON } from "../../uri";
import Cookies from "js-cookie";
import {toast} from "react-toastify";
import i18n from "../../i18n";
import store from "..";

const import_types = [
  {
    key: "ASSET",
    dispatchImport: ASSET_IMPORT,
    dispatchCheck: CHECK_ASSET_IMPORT,
    dispatchImportError: ASSET_IMPORT_ERROR,
    dispatchCheckError: CHECK_ASSET_IMPORT_ERROR,
    uri: "assets",
  },
  {
    key: "CLIENT",
    dispatchImport: CLIENT_IMPORT,
    dispatchCheck: CHECK_CLIENT_IMPORT,
    dispatchImportError: CLIENT_IMPORT_ERROR,
    dispatchCheckError: CHECK_CLIENT_IMPORT_ERROR,
    uri: "clients",
  },
  {
    key: "RELATION",
    dispatchImport: RELATION_IMPORT,
    dispatchCheck: CHECK_RELATION_IMPORT,
    dispatchImportError: RELATION_IMPORT_ERROR,
    dispatchCheckError: CHECK_RELATION_IMPORT_ERROR,
    uri: "relations",
  },
  {
    key: "DISTRIBUTOR",
    dispatchImport: DISTRIBUTOR_IMPORT,
    dispatchCheck: CHECK_DISTRIBUTOR_IMPORT,
    dispatchImportError: DISTRIBUTOR_IMPORT_ERROR,
    dispatchCheckError: CHECK_DISTRIBUTOR_IMPORT_ERROR,
    uri: "distributors",
  },
  {
      key: "SERVICE_PROVIDER",
      dispatchImport: SERVICE_PROVIDER_IMPORT,
      dispatchCheck: CHECK_SERVICE_PROVIDER_IMPORT,
      dispatchImportError: SERVICE_PROVIDER_IMPORT_ERROR,
      dispatchCheckError: CHECK_SERVICE_PROVIDER_IMPORT_ERROR,
      uri: "service-providers",
    },
];

const selectedType = (type: string) =>
  import_types.filter((t) => t.key === type)[0];

const toastStyle = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};


export const getHeaders = () => {
  const accessToken = Cookies.get("accessToken");
  if (accessToken !== undefined && accessToken !== null) {
    axios.defaults.headers.common["X-Jwt"] = accessToken;
  }
}


export const partyImport =
  (type: string, file: FormData, anonymize: any) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios({
        method: "post",
        url: `${baseUri}/connector-file/standard/file-import/${
          selectedType(type).uri
        }/import?anonymize=${anonymize}`,
        data: file,
      });
      dispatch({
        type: selectedType(type).dispatchImport,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), toastStyle);
    } catch (e) {
      dispatch({
        type: selectedType(type).dispatchImportError,
        payload: console.log(
          `%c\n CHECK_${selectedType(
            type
          ).key.toUpperCase()}_IMPORT_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), toastStyle);
    }
  };

export const checkPartyImport =
  (type: string, file: FormData) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.post(
        `${baseUri}/connector-file/standard/file-import/${
          selectedType(type).uri
        }/check`,
        file
      );
      dispatch({
        type: selectedType(type).dispatchCheck,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), toastStyle);
    } catch (e) {
      dispatch({
        type: selectedType(type).dispatchCheckError,
        payload: console.log(
          `%c\n CHECK_${selectedType(
            type
          ).key.toUpperCase()}_IMPORT_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), toastStyle);
    }
  };

export const clientImport =
  (file: FormData, anonymize: any) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios({
        method: "post",
        url: `${baseUri}/connector-file/standard/file-import/clients/import?anonymize=${anonymize}`,
        data: file,
      });
      dispatch({
        type: CLIENT_IMPORT,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: CLIENT_IMPORT_ERROR,
        payload: console.log(
          `%c\n CHECK_CLIENT_IMPORT_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const checkClientImport =
  (file: FormData) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.post(
        `${baseUri}/connector-file/standard/file-import/clients/check`,
        file
      );

      dispatch({
        type: CHECK_CLIENT_IMPORT,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: CHECK_CLIENT_IMPORT_ERROR,
        payload: console.log(
          `%c\n CHECK_CLIENT_IMPORT_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const relationImport =
  (file: FormData, anonymize: any) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios({
        method: "post",
        url: `${baseUri}/connector-file/standard/file-import/relations/import?anonymize=${anonymize}`,
        data: file,
      });
      dispatch({
        type: RELATION_IMPORT,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: RELATION_IMPORT_ERROR,
        payload: console.log(
          `%c\n CHECK_RELATION_IMPORT_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const checkRelationImport =
  (file: FormData) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.post(
        `${baseUri}/connector-file/standard/file-import/relations/check`,
        file
      );
      dispatch({
        type: CHECK_RELATION_IMPORT,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: CHECK_RELATION_IMPORT_ERROR,
        payload: console.log(
          `%c\n CHECK_RELATION_IMPORT_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const getAllEmailTemplates =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.get(
        `${baseUri}/service-notification/v1/mails/list`
      );
      dispatch({
        type: GET_ALL_EMAIL_TEMPLATES,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: GET_ALL_EMAIL_TEMPLATES_ERROR,
        payload: console.log(
          `%c\n GET_ALL_EMAIL_TEMPLATES_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const getEmailTemplateByType =
  (fileType: any, language: any) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.get(
        `${baseUri}/service-notification/v1/mails/file/${fileType}/${language}`
      );
      dispatch({
        type: GET_EMAIL_TEMPLATE_BY_TYPE,
        payload: res.data,
      });
      toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: GET_EMAIL_TEMPLATE_BY_TYPE_ERROR,
        payload: console.log(
          `%c\n GET_EMAIL_TEMPLATE_BY_TYPE_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const addEmailTemplateByType =
  (file: FormData, fileType: any, language: any) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      const res = await axios.put(
        `${baseUri}/service-notification/v1/mails/file/${fileType}/${language}`,
        file
      );
      dispatch({
        type: ADD_EMAIL_TEMPLATE_BY_TYPE,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: ADD_EMAIL_TEMPLATE_BY_TYPE_ERROR,
        payload: console.log(
          `%c\n ADD_EMAIL_TEMPLATE_BY_TYPE_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };
export const getAllProperties =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.get(`${baseUri}/service-person/v1/properties`);
      dispatch({
        type: GET_ALL_PROPERTIES,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: GET_ALL_PROPERTIES_ERROR,
        payload: console.log(
          `%c\n GET_ALL_PROPERTIES_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
export const edit_Properties =
  (prop: any) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.put(
        `${baseUri}/service-person/v1/properties/${prop.key}`,
        prop
      );
      dispatch({
        type: EDIT_PROPERTIES,
        payload: res.data,
      });
      toast.success(i18n.t("UPDATED"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: EDIT_PROPERTIES_ERROR,
        payload: console.log(
          `%c\n EDIT_PROPERTIES_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const edit_Properties_list =
  (prop: any) =>
  async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axios.put(
        `${baseUri}/service-person/v1/properties/${prop.key}/list`,
        prop
      );
      dispatch({
        type: EDIT_PROPERTIES_LIST,
        payload: res.data,
      });
      toast.success(i18n.t("UPDATED"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: EDIT_PROPERTIES_LIST_ERROR,
        payload: console.log(
          `%c\n EDIT_PROPERTIES_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  export const addTeamLogo =
  (file: FormData, teamId: string) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      const res = await axios.put(
        `${baseUriUsers}/service-user/v1/teams/${teamId}/logo`,
        file
      );
      console.log(res.data)
      dispatch({
        type: ADD_TEAM_LOGO,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: ADD_TEAM_LOGO_ERROR,
        payload: console.log(
          `%c\n ADD_TEAM_LOGO_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const addClientLogo =
  (file: FormData) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      const res = await axios.put(
        `${baseUri}/service-person/v1/admin/logo`,
        file
      );
      dispatch({
        type: ADD_CLIENT_LOGO,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      dispatch({
        type: ADD_CLIENT_LOGO_ERROR,
        payload: console.log(
          `%c\n ADD_CLIENT_LOGO_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const getClientLogo =
  () => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      let logo;
      const res = await axios.get(
        `${URL_SERVICE_PERSON}/service-person/v1/properties/logo`
      );
      dispatch({
        type: GET_CLIENT_LOGO,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: GET_CLIENT_LOGO_ERROR,
        payload: console.log(
          `%c\n GET_CLIENT_LOGO_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const getUserRoles =
  (userId: any) =>
  async (dispatch: (arg0: { type: string; payload: void }) => void) => {
    const {
      Users: { get_properties },
    } = store.getState();
    let version = null;

    if (
      get_properties.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
    ) {
      version = "v2";
    } else {
      version = "v1";
    }

    try {
      const res = await axios.get(
        `${baseUriUsers}/service-user/${version}/users/${userId}/authorizations`
      );
      dispatch({
        type: GET_USER_ROLE,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: GET_USER_ROLE_ERROR,
        payload: console.log(
          `%c\n GET_USER_AUTH_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getClientsFiltered =
  (filter: any) =>
  async (dispatch: (arg0: { type: string; payload: void }) => void) => {
    try {
      const queryString = window.location.search;
      const res = await axios.get(
        `${baseUriUsers}/service-user/v1/users${
          filter ? `?${filter}&size=7` : "?size=7"
        }`
      );
      dispatch({
        type: GET_CLIENTS_FILTERED,
        payload: res.data,
      });
    } catch (e) {
      if (e.code !== "ECONNABORTED") {
        dispatch({
          type: GET_CLIENTS_FILTERED_ERROR,
          payload: console.log(
            `%c\n GET_CLIENTS_FILTERED_ERROR ⤶ \n   ${e} \n`,
            "background: #FF000B; color: #F7FF00"
          ),
        });
        toast.error(i18n.t("ERROR_MESSAGES.URL"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const countByInternal =
  () => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${baseUriUsers}/service-user/v1/users/count-by-internal`
      );
      dispatch({
        type: GET_BY_INTERNAL,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: GET_BY_INTERNAL_ERROR,
        payload: console.log(
          `%c\n UPDATE_USERS_ROLE_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
    }
  };

export const updateUsersRole =
  (userId: any, role: any, name: string, value: string) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    const {
      Users: { get_properties },
    } = store.getState();
    let version = null;

    if (
      get_properties?.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
    ) {
      version = "v2";
    } else {
      version = "v1";
    }

    try {
      role[name] = value;
      const res = await axios.put(
        `${baseUriUsers}/service-user/${version}/users/${userId}/authorizations`,
        role
      );
      dispatch({
        type: UPDATE_USERS_ROLE,
        payload: res.data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: UPDATE_USERS_ROLE_ERROR,
        payload: console.log(
          `%c\n UPDATE_USERS_ROLE_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getMeAuth =
  () => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    const {
      Users: { get_properties },
    } = store.getState();
    let version = null;
    if (
      get_properties?.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
    ) {
      version = "v2";
    } else {
      version = "v1";
    }

    try {
      getHeaders();
        dispatch({
          type: GET_ME_AUTH_PENDING,
          payload: console.log(
            `%c\n GET_ME_AUTH_PENDING ⤶  \n`,
            "background: #FF000B; color: #F7FF00"
          ),
        });

      const res = await axios.get(
        `${baseUriUsers}/service-user/${version}/authorizations/me`
      );
      dispatch({
        type: GET_ME_AUTH,
        payload: res.data,
      });
    } catch (e) {
      if (e.response && (e.response.status === 401 || e.response.status === 403)) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: GET_ME_AUTH_ERROR,
        payload: console.log(
          `%c\n GET_ME_AUTH_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getAuthorizationValues =
  () => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${baseUriUsers}/service-user/v2/authorizations/values`
      );
      dispatch({
        type: GET_AUTH_VALUES,
        payload: res.data,
      });
    } catch (e) {
      if (e.response && e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: GET_AUTH_VALUES_ERROR,
        payload: console.log(
          `%c\n GET_AUTH_VALUES_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getMe =
  () => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      getHeaders();
      const res = await axios.get(`${baseUriUsers}/service-user/v1/users/me`);
      dispatch({
        type: GET_ME,
        payload: res.data,
      });
    } catch (e) {
      if (e.response && (e.response.status === 401 || e.response.status === 403)) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: GET_ME_ERROR,
        payload: console.log(
          `%c\n GET_ME_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getAllUsers =
  (refresh: boolean) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      const res = await axios.get(
        `${baseUriUsers}/service-user/v1/users?page=0&size=7`
      );
      dispatch({
        type: GET_USERS,
        payload: res.data,
      });
    } catch (e) {
      if (e.response && (e.response.status === 401 || e.response.status === 403)) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: USERS_ERROR,
        payload: console.log(
          `%c\n USERS_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

// CREATION USER

export const createUser =
  (user: any) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    const {
      Users: { get_properties },
    } = store.getState();
    let version = null;

    if (
      get_properties?.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
    ) {
      version = "v2";
    } else {
      version = "v1";
    }
    try {
      const res = await axios
        .post(`${baseUriUsers}/service-user/${version}/users`, user)
        .then(() => {});

      dispatch({
        type: CREATE_USER,
        payload: res,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: CREATE_USER_ERROR,
        payload: console.log(
          `%c\n CREATE_USER_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const paginateUsers =
  (pageNumber: any, filter: string) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      let res;
      if (filter !== "" && filter !== undefined) {
        res = await axios.get(
          `${baseUriUsers}/service-user/v1/users?page=${pageNumber - 1}${
            filter && `&${filter}`
          }&size=7`
        );
      } else {
        res = await axios.get(
          `${baseUriUsers}/service-user/v1/users?page=${pageNumber - 1}&size=7`
        );
      }

      dispatch({
        type: PAGINATE_USERS,
        payload: res.data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: PAGINATE_USERS_ERROR,
        payload: console.log(
          `%c\n PAGINATE_USERS_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const getUser =
  (id: string) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      const res = await axios.get(`${baseUriUsers}/service-user/v1/users/${id}`);
      dispatch({
        type: GET_USER,
        payload: res.data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: GET_USER_ERROR,
        payload: console.log(
          `%c\n GET_USER_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const editUser = (user: any) => async (dispatch: any) => {
  try {
    const editedUser = {
      email: user.email,
      firstName: user.firstName,
      internal: user.internal,
      language: user.language,
      name: user.name,
      password: user.password,
      role: user.role,
      canLogin: user.canLogin,
      canReceiveOngoingScreeningEmail: user.canReceiveOngoingScreeningEmail,
      subRole: user.subRole,
    };
    const res = await axios.put(
      `${baseUriUsers}/service-user/v1/users/${user.id}`,
      editedUser
    );
    dispatch({
      type: EDIT_USER,
      payload: res.data,
    });
    toast.success(i18n.t("SUCCESS"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    dispatch({
      type: EDIT_USER_ERROR,
      payload: console.log(
        `%c\n EDIT_USER_ERROR ⤶ \n   ${e} \n`,
        "background: #FF000B; color: #F7FF00"
      ),
    });
    if (e.response.status === 403) {
      toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
};

export const editMe = (me: any) => async (dispatch: any) => {
  try {
    const editedMe = {
      email: me.email,
      firstName: me.firstName,
      internal: me.internal,
      language: me.language,
      name: me.name,
      password: me.password,
      role: me.role,
      subRole: me.subRole,
    };
    const res = await axios.put(
      `${baseUriUsers}/service-user/v1/users/${me.id}`,
      editedMe
    );
    dispatch({
      type: EDIT_ME,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    dispatch({
      type: EDIT_USER_ERROR,
      payload: console.log(
        `%c\n EDIT_USER_ERROR ⤶ \n   ${e} \n`,
        "background: #FF000B; color: #F7FF00"
      ),
    });
    if (e.response.status === 403) {
      toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
};

export const updateUserMe =
  (userId: string, data: any) =>
  async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.put(
        `${baseUriUsers}/service-user/v1/users/${userId}`,
        data
      );
      dispatch({
        type: UPDATE_USER_ME,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: UPDATE_USER_ME_ERROR,
        payload: console.log(
          `%c\n UPDATE_USER_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGE.TOKEN"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
  };

export const updateUser =
  (field: string, value: string, user: any) =>
  async (dispatch: (arg0: { type: string; payload: any }) => void) => {
    try {
      user[field] = value;
      dispatch({
        type: UPDATE_USER,
        payload: user,
      });
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove("authToken");
        Cookies.remove("accessToken");
        window.location.href = `${loginUri}${envHost}`;
      }
      dispatch({
        type: UPDATE_USER_ERROR,
        payload: console.log(
          `%c\n UPDATE_USER_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      window.location.reload();
      if (e.response.status === 403) {
        toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const getAllAvailableLanguageAction =
  () => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.get(`${baseUri}/service-person/v1/available-language`);
      const availableLanguage = res.data as AvailableLanguageDTO[] || [];
      const langs = availableLanguage.sort((a, b) => a.languageCode.localeCompare(b.languageCode))

      dispatch({
        type: GET_AVAILABLE_LANGUAGE,
        payload: langs,
      });
    } catch (e) {
      dispatch({
        type: GET_AVAILABLE_LANGUAGE_ERROR,
        payload: console.log(
          `%c\n GET_AVAILABLE_LANGUAGE_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
};

export const selectAvailableLanguageAction =
  (languagesCodes: string[]) => async (dispatch: (arg0: { type: any; payload: any }) => void) => {
    try {
      const res = await axios.post(`${baseUri}/service-person/v1/available-language`, languagesCodes);
      const availableLanguage = res.data as AvailableLanguageDTO[] || [];
      const langs = availableLanguage.sort((a, b) => a.languageCode.localeCompare(b.languageCode))

      dispatch({
        type: GET_AVAILABLE_LANGUAGE,
        payload: langs,
      });
    } catch (e) {
      dispatch({
        type: GET_AVAILABLE_LANGUAGE_ERROR,
        payload: console.log(
          `%c\n GET_AVAILABLE_LANGUAGE_ERROR ⤶ \n   ${e} \n`,
          "background: #FF000B; color: #F7FF00"
        ),
      });
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
};
